import { checkoutError } from 'store/checkout/checkoutActions';
import { createCheckoutErrorEvent } from '../eventCreators';
import { createCheckoutErrorEventPayload } from '../dataHelpers/createCheckoutErrorEventPayload';

const emitCheckoutError = ({ payload }) => {
  const checkoutErrorEvent = createCheckoutErrorEvent(
    createCheckoutErrorEventPayload({
      errors: payload?.errors,
    }),
  );

  return checkoutErrorEvent;
};

// eslint-disable-next-line
// @ts-ignore
export default { [checkoutError]: emitCheckoutError };
